<rps-page-title title="Testimonials"></rps-page-title>
<spa-common-page-slice sliceContentClass="layout">
  <spa-common-testimonial *ngFor="let testimonial of testimonials"
                          [testimonial]="testimonial"
  ></spa-common-testimonial>
</spa-common-page-slice>

